import { SagaIterator } from "redux-saga"
import { put, takeLatest } from "redux-saga/effects"
import { history } from "store"

import { notifyIfServerError } from "../utils"
import * as actions from "./url.actions"

const clearParams = (urlParams: URLSearchParams) => {
  urlParams.forEach((_, key) => {
    urlParams.delete(key)
  })
}

const appendParams = (urlParams: URLSearchParams, params: any) => {
  Object.keys(params).forEach((key: string) => {
    const value = params[key]
    if (Array.isArray(value)) {
      return value.forEach((v: string) => {
        urlParams.append(key, v)
      })
    }
    if (value) {
      urlParams.append(key, value)
    }
  })
}

const paramsToObject = (urlParams: URLSearchParams, arrayParams?: string[]) => {
  const result: any = {}
  for (const pair of urlParams.entries()) {
    const key = pair[0]
    if (arrayParams && arrayParams.includes(key)) {
      result[key] = urlParams.getAll(key)
      continue
    }
    result[key] = urlParams.get(key)
  }
  return result
}

export function* setUrlFlow(action: actions.SetUrlAction): SagaIterator {
  try {
    const { path, params, arrayParams } = action.payload
    const urlParams = new URLSearchParams()
    clearParams(urlParams)
    appendParams(urlParams, params)
    history.push(`${path}?${urlParams.toString()}`)
    const data = paramsToObject(urlParams, arrayParams)
    yield put(
      actions.setUrlSuccess({
        params: data,
        path,
      }),
    )
  } catch (e) {
    yield put(notifyIfServerError({ error: e }))
  }
}

function* setExistingUrlFlow(action: actions.SetExistingUrlAction): SagaIterator {
  try {
    const { path, arrayParams, currentParams } = action.payload
    const {search} = history.location
    const data = paramsToObject(new URLSearchParams(search), arrayParams)
    const params = { ...currentParams, ...data }
    yield put(actions.setUrl({ path, params, arrayParams }))
    yield put(
      actions.setUrlSuccess({
        params,
        path,
      }),
    )
  } catch (e) {
    yield put(notifyIfServerError({ error: e }))
  }
}

function* resetUrlFlow(): SagaIterator {
  try {
    const urlParams = new URLSearchParams()
    clearParams(urlParams)
  } catch (e) {
    yield put(notifyIfServerError({ error: e }))
  }
}

export default function* urlSaga(): SagaIterator {
  yield takeLatest(actions.Types.SET_URL, setUrlFlow)
  yield takeLatest(actions.Types.SET_EXISTING_URL, setExistingUrlFlow)
  yield takeLatest(actions.Types.RESET_URL, resetUrlFlow)
}
